export const twoConnectThemeSettings = {
  // indicates what percentage each color represents in the theme documentation:
  // light: "60%"
  // main: "80%"
  // dark: "100%"
  // soft: "10%"
  // pale: "40%"
  palette: {
    mode: "light",
    primary: {
      light: "#5f6ca7",
      main: "#2f418f",
      dark: "#001677",
      soft: "#d8dae4",
      bgColor: "#d9dae3",
      pale: "#9099bf",
      contrastText: "#fff"
    },
    secondary: {
      light: "#5fbeec",
      main: "#2fadeb",
      dark: "#009dea",
      soft: "#d8e7ef",
      pale: "#90ceed",
      contrastText: "#efefef"
    },
    primaryReverse: {
      light: "#000000",
      main: "#e0e0e0",
      dark: "#e0e0e0",
      pale: "#d5d8d9",
      contrastText: "#33373B"
    },
    error: {
      main: "#ED0000",
      contrastText: "#fff"
    },
    warning: {
      main: "#FFD84E",
      light: "#dbc188",
      secondary: "#fff6e6",
      contrastText: "#fff"
    },
    info: {
      main: "#000FF0"
    },
    success: {
      main: "#9EFF00",
      secondary: "#6ba53a",
      contrastText: "#fff"
    },
    mainButton: {
      main: "#2f418f",
      contrastText: "#fff"
    },
    mainButtonReverse: {
      main: "#fff",
      contrastText: "#2f418f"
    },
    secondaryButton: {
      main: "#fff",
      contrastText: "#000"
    },
    slider: {
      main: "#7e57a3",
      contrastText: "#fff"
    },
    userBar: {
      background: "#001677"
    },
    diagramColors: {
      warning: "#ffa200",
      error: "#ff0000",
      info: "#005db9",
      success: "#8fd400",
      default: "#000000",
    },
  },
  typography: {
    fontFamily: '"Nexa", sans-serif',
    h1: {
      fontSize: "48px",
      fontWeight: "bold",
      fontFamily: '"Nexa", sans-serif'
    },
    h2: {
      fontSize: "36px",
      fontWeight: "bold",
      fontFamily: '"Nexa", sans-serif'
    },
    h3: {
      fontSize: "24px",
      fontWeight: "bold",
      fontFamily: '"Nexa", sans-serif'
    },
    h4: {
      fontSize: "20px",
      fontWeight: "bold",
      fontFamily: '"Nexa", sans-serif'
    },
    h5: {
      fontFamily: '"Nexa", sans-serif'
    },
    h6: {
      fontFamily: '"Nexa", sans-serif'
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px', // Legyen a gomb lekerekített
          '&.MuiButton-sizeLarge': { // Csak akkor legyen 19px, ha primary a szín
            fontSize: '19px',
            fontWeight: 'bold',
          },
        },
      }
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        rounded: {
          borderRadius: "16px",
          boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.16)',
        }
      }
    },
    muiTableProps: {
      PaperProps: {
        elevation: 0
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "6px",
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: "#00A4B2" //theme.palette.secondary.main,
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff"
        }
      }
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff"
        }
      }
    },
  }
};